import React from "react";
import Expansion from "components/ExpansionComponent"
import { withStyles } from "@material-ui/core";
import { ApproverComponent } from "content/Event/ScheduleEvent/PublishEvent/publishEvent"
import { parseDateToPropertyTimezone } from "content/Event/util/index.js"
import EventDateTime from "storybookComponents/EditableLabel/event-time.js"
import Picker from "storybookComponents/Picker";
import Button from "storybookComponents/Button"
import "./style.css"
import { getMinValidDate } from "content/Event/util/date";

const styles = () => ({
  divider: {
    height: 1,
    background: '#EEEEEE',
    margin: "20px 0px"
  },
  subtitle: {
    fontSize: 14,
    fontFamily: "Open Sans",
    color: "rgba(51, 51, 51, 0.75)",
    lineHeight: "20px"
  },
  bodyMargin: {
    marginTop: 12
  },
  emailItem: {
    padding: "2px 8px",
    height: 28,
    border: "1px solid #EEEEEE",
    marginRight: 12,
    marginTop: 16
  },
  emailflex: {
    display: "flex",
    alignItems: "center",
    flexWrap: "wrap",
  },
  textApprover: {
    marginTop: 12,
    height: 40,
    fontSize: 14,
    color: "rgba(51,51,51,0.75)",
  },
  headerIcon: {
    marginLeft: 8,
    height: 26,
    width: 23,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    fontSize: 12,
    background: "#F9F9F9"
  },
  dateClass: {
    fontFamily: "Open Sans",
    fontWeight: "600",
    fontSize: 20,
    width: "auto",
  },
  input: {
    fontSize: 20,
    fontWeight: 600,
    cursor: "pointer",
    "&:hover": {
      color: "#26bbed",
    },
  },
  pickerContainer: {
    marginTop: 16,
    fontSize: 20,
    justifyContent: "left",
    fontWeight: 600
  },
  dateContainer: {
    width: 128,
  },
  timeContainer: {
    width: 90,
  },
  textField: {
    width: 240,
    height: 40,
    marginTop: 20
  },
  btnStyle: {
    textTransform: "none"
  },
  bottomButtons: {
    marginTop: 36,
    textAlignLast: "right"
  }
})

const RescheduleBody = ({ classes, approverSettings, event, isApprover, subOrgDetails, toggler, showNotification, handleRescheduleCallback }) => {
  const [minValidDate, setMinValidDate] = React.useState(
    getMinValidDate(
      subOrgDetails.timezoneString,
      !(approverSettings.approvalRequired && !isApprover)
    )
  );
  const [active, setActive] = React.useState(false);
  const dates = parseDateToPropertyTimezone(event, subOrgDetails.timezoneString);
  const [eventDateTime, setEventDateTime] = React.useState({
    startAt: dates.startAt,
    endAt: dates.endAt
  })
  const [publishDate, setPublishDate] = React.useState(dates.publishAt);
  const [expanded, setExpanded] = React.useState("First");

  const onError = (msg) => {
    showNotification(msg, "error")
  }

  const handleExpandedPanel = (panel) => {
    if (panel === expanded)
      setExpanded("");
    else
      setExpanded(panel);
  };

  const handleChange = (value) => {
    setEventDateTime(value)
  }

  const handleDate = (value) => {
    setPublishDate(value)
  }

  const getButtonState = () => {
    if (active) return "inactive";
    if (dates.startAt) {
      if ((dates.startAt.isSame(eventDateTime.startAt) && dates.endAt.isSame(eventDateTime.endAt)) && dates.publishAt.isSame(publishDate)) {
        return "inactive"
      } else {
        return "active"
      }
    }
  }

  const handleReschedule = async () => {
    setActive(true);
    await handleRescheduleCallback(
      event,
      eventDateTime.startAt,
      eventDateTime.endAt,
      publishDate.toISOString()
    );
    setActive(false);
    toggler();
  };
  return (
    <div className="reschedule-hyly">
      <Expansion
        expanded={expanded === "First"}
        handleExpandedPanel={handleExpandedPanel}
        name="First"
        header={`Select new date & time for '${event.eventTitle}'`}>
        <div className={classes.bodyMargin} >
          <div className={classes.subtitle}>A confirmation email for reschdeling the event would be sent to all the selected contacts once it is approved</div>
          <EventDateTime
            value={eventDateTime}
            onChange={handleChange}
            timezoneString={subOrgDetails.timezoneString}
            timezoneAbbr={subOrgDetails.timezoneAbbr}
            classes={classes}
            onError={onError}
          />

        </div>
      </Expansion>
      <div className={classes.divider}></div>
      <Expansion
        expanded={expanded === "Second"}
        handleExpandedPanel={handleExpandedPanel}
        name="Second"
        header="Select publish date and time on property website">
        <div className={classes.bodyMargin}>
          <div className={classes.subtitle}>The event would be published on property website at scheduled date & time, only when it is approved.</div>
          <div id="hyly-datePicker" className={classes.textField}>
            <Picker format={true} type="datetime" icon={true} handleChange={handleDate} placeholderText="Date & Time" defaultValue={publishDate} minValidDate={minValidDate} timezoneAbbr={subOrgDetails.timezoneAbbr} timezoneString={subOrgDetails.timezoneString} />
          </div>
        </div>
      </Expansion>
      {
        approverSettings.approvalRequired && !isApprover &&
        <>
          <div className={classes.divider}></div>
          <ApproverComponent expanded={expanded === "approvers"} handleExpandedPanel={handleExpandedPanel} approverSettings={approverSettings} classes={classes} />
        </>
      }
      <div className={classes.bottomButtons}>
        <Button color="darkBlack" className={classes.btnStyle} variant="tertiary" size="md" onClick={toggler}>
          Cancel
        </Button>
        <Button color="hylyBlue" className={classes.btnStyle} state={getButtonState()} type="submit" variant="primary" size="md" onClick={handleReschedule}>
          {
            (approverSettings.approvalRequired && !isApprover) ? " Resend for approval" : "Reschedule Event"
          }

        </Button>
      </div>

    </div>
  )
}

export default withStyles(styles)(RescheduleBody)